import { styled } from "@mui/system";
import {Button } from "@mui/material";
const MyButton = styled(Button)({
    color: "#ffffff",
    backgroundColor: "#FF6B6B",
    ":hover": {
      backgroundColor: "#ffffff",
      color: "#FF6B6B",
    },
  });



export default MyButton;